import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@environment';
import { OktaUserModel } from '../models/user/okta-user.model';

@Injectable()
export class UserProfileService {

  constructor(private http: HttpClient) {
  }

  public getTecToken(): Observable<string> {
    return this.http.get<string>(`${environment.userServiceUrl}/user/token`);
  }

  public getNewUser(token: string, uid: string): Observable<OktaUserModel> {
    const headers = new HttpHeaders({
      'X-Tec-Token': token
    });

    return this.http.get<OktaUserModel>(`${environment.userServiceUrl}/v1/users/${uid}`, { headers });
  }
}
